module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "h2f"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vi",
      "title": "vi"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf01",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/00a_fm0f"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf0",
    attrs: {
      "id": "list"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/00a_fm0g"
    }
  }, [_c('i', [_vm._v("List of Abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "int"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/00b_intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ent1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/01_entracte01"
    }
  }, [_vm._v("Entr’Acte 1: "), _c('i', [_vm._v("The Michigan Film Review")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/02_ch01"
    }
  }, [_vm._v("1"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Mapping Circulation in Detroit’s Movie Market")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ent2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/03_entracte02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Entr’Acte 2: Detroit Area Picture Theaters")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ent3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/04_entracte03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Entr’Acte 3: John H. Kunsky and George W. Trendle")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/05_ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Movies, Live Acts, and the Theatrical Experience: Programming Practices in the Motor City")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ent4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/06_entracte04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Entr’Acte 4: Detroit-Made Films")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ent5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/07_entracte05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Entr’Acte 5: The Metropolitan Film Company")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/08_ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("“Detroit-Made” Newsreels and Other Short Nonfiction Films")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ent6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/09_entracte06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Entr’Acte 6: Star Gazing")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/10_ch04_final",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Motor City Menus for Movie Fans")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf1",
    attrs: {
      "id": "aft"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/11_afterword",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf0",
    attrs: {
      "id": "bib"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/12_bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf2",
    attrs: {
      "id": "ind"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/13_Index",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bfca1d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/00a_fm0e.vue
// module id = 72
// module chunks = 0